import { useMemo } from 'react';

import { PartnerCardType } from 'apis/partnerIntegrations';
import { FeatureFlagName } from 'utils/featureFlagging/featureFlags';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';

type PartnerFeatureFlagKeys = PartnerCardType | 'ASSEMBLED';

export type PartnerWidgetFeatureFlags = Record<PartnerFeatureFlagKeys, boolean>;

const flags: FeatureFlagName[] = [
  'partner-integrations-widget-jira',
  'partner-integrations-widget-shopify',
  'partner-integrations-widget-github',
  'partner-integrations-widget-miuros',
  'partner-integrations-widget-linear',
  'partner-integrations-widget-klaviyo',
  'partner-integrations-widget-voyado',
  'partner-integrations-widget-loyaltylion',
  'partner-integrations-widget-recharge',
  'partner-integrations-widget-braze',
  'partner-integrations-widget-yotpo',
  'partner-integrations-datasync-assembled',
  'partner-integrations-widget-ingrid',
  'partner-integrations-widget-rivoloyalty',
];

/** Hook to get widget feature-flag states by widget type. */
export function usePartnerWidgetFeatureFlags(): PartnerWidgetFeatureFlags {
  const featureFlags = useFeatureFlag(flags);

  return useMemo(
    () => ({
      JIRA: featureFlags.partnerIntegrationsWidgetJira,
      SHOPIFY: featureFlags.partnerIntegrationsWidgetShopify,
      GITHUB: featureFlags.partnerIntegrationsWidgetGithub,
      MIUROS: featureFlags.partnerIntegrationsWidgetMiuros,
      LINEAR: featureFlags.partnerIntegrationsWidgetLinear,
      KLAVIYO: featureFlags.partnerIntegrationsWidgetKlaviyo,
      VOYADO: featureFlags.partnerIntegrationsWidgetVoyado,
      LOYALTYLION: featureFlags.partnerIntegrationsWidgetLoyaltylion,
      RECHARGE: featureFlags.partnerIntegrationsWidgetRecharge,
      BRAZE: featureFlags.partnerIntegrationsWidgetBraze,
      YOTPO: featureFlags.partnerIntegrationsWidgetYotpo,
      ASSEMBLED: featureFlags.partnerIntegrationsDatasyncAssembled,
      INGRID: featureFlags.partnerIntegrationsWidgetIngrid,
      RIVOLOYALTY: featureFlags.partnerIntegrationsWidgetRivoloyalty,
    }),
    [featureFlags],
  );
}
